<template>
    <modal :show="show" v-on:update:show="handleModalClose" v-if="number">
        <template slot="header">
            <h5 class="modal-title">
                {{ number.tag ? number.tag + ' (' + number.formatted_did + ')': number.formatted_did
                }}'s settings</h5>
        </template>

        <template>
            <form>
                <div class="row">
                    <div class="col">
                        <base-input label="Name"
                                    type="text"
                                    placeholder="Enter name"
                                    v-model="number.tag"
                                    name="name"
                                    required
                        >
                            <small slot="helperText" id="nameHelp" class="form-text text-muted">This will be used
                                throughout
                                the
                                portal to identify this number.
                            </small>
                        </base-input>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col">
                        <p class="category">Block Anonymous calls?</p>
                        <base-switch off-text="NO" on-text="YES" v-model="number.block_anonymous"></base-switch>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col">
                        <music-on-hold-selector @change="dirty = true"
                                                v-model="number.musiconhold"></music-on-hold-selector>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-lg-4">
                        <p class="category">Enable Call Recording?</p>
                        <base-switch off-text="OFF" on-text="ON" v-model="recordingEnabled"></base-switch>
                    </div>
                    <div class="form-group col-lg-8" v-if="recordingEnabled">
                        <base-input label="Recording Email"
                                    type="email"
                                    class="animated"
                                    v-bind:class="{fadeInRight: recordingEnabled}"
                                    placeholder="Enter email"
                                    required
                                    name="email"
                                    :error="getError('email')"
                                    v-validate="'required|email'"
                                    v-model="number.recordingemail"
                        >
                            <small slot="helperText" id="emailHelp" class="form-text text-muted">Call recordings will be
                                sent to this address.
                            </small>
                            <small slot="helperText" id="callrecordingHelp" class="form-text text-muted">A monthly
                                charge of 2 {{ this.$store.getters['customer/currency'] }} will be added to your account
                            </small>
                        </base-input>
                    </div>

                </div>
            </form>
        </template>


        <template slot="footer">
            <base-button type="primary" native-type="submit" @click.prevent="validate"
                         :loading="saving"> Save changes
            </base-button>
            <base-button type="secondary" @click.native="$emit('update:show', false)">Close</base-button>
        </template>
    </modal>
</template>

<script>
    import Modal from "../../components/Modal";
    import BaseSwitch from "../../components/BaseSwitch";
    import MusicOnHoldSelector from "../../components/MusicOnHold/MusicOnHoldSelector";

    export default {
        name: "NumberSettingsModal",
        components: {
            MusicOnHoldSelector,
            Modal,
            BaseSwitch
        },
        props: {
            initialNumber: {},
            show: Boolean,
        },
        data() {
            return {
                saving: false,
                number: JSON.parse(JSON.stringify(this.initialNumber)),
                recordingEnabled: false,
            }
        },
        methods: {
            getError(fieldName) {
                return this.errors.first(fieldName)
            }
            ,
            validate() {
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        this.updateSettings()
                    }
                })
            },
            handleModalClose(value) {
                this.$emit('update:show', value);
            },
            updateSettings() {
                this.saving = true;
                this.$store.dispatch('did/saveSettings', {number: this.number}).then(() => {
                    this.saving = false;
                    this.$notify({
                        verticalAlign: 'bottom',
                        horizontalAlign: 'right',
                        message: this.number.formatted_did + '\'s settings saved!',
                        type: "success",
                        icon: "fal fa-save",
                        title: "Saved!"
                    });


                    this.$emit('update:show', false);

                }).catch(() => {
                    this.saving = false;
                    this.$notify({
                        position: "bottom-right",
                        message: this.number.formatted_did + '\'s settings failed to save!',
                        type: "error",
                        icon: "fal fa-times",
                        title: "Error!"
                    });
                }).finally(() => {
                    this.$store.dispatch('did/loadUniqueDIDs');
                });
            },
        }
        ,
        mounted() {
        }
        ,
        watch: {
            // whenever sipdevice changes, this function will run
            initialNumber: function (newNumber, oldNumber) {
                this.number = newNumber;
                this.recordingEnabled = !!this.number.recordingemail;
            },
            recordingEnabled: function (newRecordingEnabled, oldRecordingEnabled) {
                this.number.recordingemail = null;
            },
        },
    }
</script>

<style scoped>

</style>
